const KEY = 'analytics_token';

/**
 * Save JWT token
 */
export function setAuthToken(token) {
  try {
    sessionStorage.setItem(KEY, token);
  } catch (error) {
    
  }
}

/**
 * Read valid JWT token
 */
export function getAuthToken() {
  try {
    if (typeof window === 'undefined') {
      return null;
    }

    const token = sessionStorage.getItem(KEY);

   

    if (!token) {
      return null;
    }

    // Decode JWT payload
    const payload = JSON.parse(atob(token.split('.')[1]));

    const nowSeconds = Math.floor(Date.now() / 1000);



    // Expire 60 seconds early
    if (payload.exp - 60 <= nowSeconds) {
      //clearAuthToken();
      return null;
    }

    return token;
  } catch (error) {
    clearAuthToken();
    return null;
  }
}

/**
 * Clear token
 */
export function clearAuthToken() {
  try {
    sessionStorage.removeItem(KEY);
  } catch (error) {
    
  }
}

/**
 * Auth status
 */
export function isAuthenticated() {
  return !!getAuthToken();
}